import React from "react";
import PropTypes from "prop-types";
import {Select, Button, Row, Col, Icon, TreeSelect} from "antd";
import './style.css';
import {PositionTypeContext} from '../../PositionAdd';
import BaseComponent from "../../../../../../base/BaseComponent";
import {generateTreeData} from "../../../../../../utils";

const {TreeNode} = TreeSelect;

/**
 * 选择部门
 */
class DeptSelect extends BaseComponent {
    constructor(props) {
        super(props);
        this.state = {
            fieldProps: {},
            suffixWidth: 0,
            value: "",
            treeData: [],
            treeDataIndex: {
                id: "id",
                title: "name",
                children: "child",
                key: "id"
            },
        };
    }

    componentDidMount() {
        const observer = new ResizeObserver((e, o) => {
            this.setState({
                suffixWidth: e[0].contentRect.width + 5 + 32,  //添加间距
            })
        });
        const suffixDom = document.querySelector(`div[data-name ='${this.props.name}'] .rmt-input-suffix-layout`);
        if (suffixDom) {
            observer.observe(suffixDom);
        }
        const {fieldProps} = this.props;
        this.setState({
            value: fieldProps.value,
        }, () => {
            this.deptGetTree();
        })
    }

    deptGetTree = () => {
        this.deptGetTreeRequest(res => {
            // 格式化树数据
            const treeData = generateTreeData(res.child, this.state.treeDataIndex);
            this.setState({
                treeData
            });
        });
    };
    deptGetTreeRequest = (callBack) => {
        this.request({
            url: "/cm-sites-sys/dept/getTree",
            body: {id: 0},
            callBack
        });
    };

    static getDerivedStateFromProps(props, state) {
        // 判断props中的属性
        if (props.fieldProps && state !== props.fieldProps) {
            let newProps = {};
            for (const key in props) {
                if (!Object.hasOwnProperty.call(DeptSelect.defaultProps, key)) {
                    newProps[key] = props[key];
                }
            }
            for (const fieldKey in props.fieldProps) {
                if (Array.isArray(props.fieldProps?.extra) && !props.fieldProps?.extra.includes(fieldKey)) {
                    newProps[fieldKey] = props.fieldProps[fieldKey];
                }
            }
            return {...state, fieldProps: {...newProps}}
        }
        return state
    }

    renderSuffixButton() {
        const {buttonProps = {}} = this.props.fieldProps;
        return (
            <>
                <Button {...buttonProps}>{buttonProps?.name}</Button>
            </>
        )
    }

    render() {
        const {prefixLayout, suffixLayout, style = {}, suffixButton} = this.props.fieldProps;
        const {fieldProps, suffixWidth, treeData, userData} = this.state;
        const itemIcon2 = <Icon type="file-text"/>;
        const ExpandedIcon = <Icon style={{color: "#ffcd2c"}} type="folder-open" theme="filled"/>;
        const ClosedIcon = <Icon style={{color: "#ffcd2c"}} type="folder" theme="filled"/>;
        const columnLoop = (data) => {
            return data.map(item => {
                let TitleIcon;
                if (item.children && item.children.length) {
                    if (this.state.value === item.id) {
                        TitleIcon = ExpandedIcon;
                    } else {
                        TitleIcon = ClosedIcon;
                    }
                } else {
                    TitleIcon = itemIcon2;
                }
                // 最终的展示 title
                let title = <div style={{display: "flex"}}>
                    <div>{TitleIcon}</div>
                    <div title={item.title} style={{
                        marginLeft: "8px",
                        width: 120,
                        overflow: "hidden",
                        whiteSpace: "nowrap",
                        textOverflow: "ellipsis"
                    }}>{item.title}</div>
                </div>;
                return <TreeNode value={item.id} title={title} key={item.id}>
                    {item.children && item.children.length ? columnLoop(item.children) : ""}
                </TreeNode>;
            });
        };
        return (
            <>
                <div className="rmt-input">
                    {
                        !!prefixLayout && <div className="rmt-input-prefix-layout">{prefixLayout}</div>
                    }
                    <div className="rmt-input-content-layout" style={style}>
                        <PositionTypeContext.Consumer>
                            {
                                value => (
                                    <>
                                        <TreeSelect
                                            {...fieldProps}
                                            showSearch={true}
                                            filterTreeNode={(input, option) => {
                                                const id = option.key;
                                                const node = this.findNodeById(treeData, id);
                                                const label = node ? node.title : '';
                                                return label.toLowerCase().indexOf(input.toLowerCase()) >= 0;
                                            }}
                                            style={{width: "100%"}}
                                            allowClear
                                            getPopupContainer={triggerNode => triggerNode.parentElement}
                                            dropdownStyle={{maxHeight: 250}}
                                            multiple={false}
                                            treeDefaultExpandAll
                                            searchPlaceholder={"请输入关键词"}
                                            value={this.state.value || undefined}
                                            onChange={(val, label, extra) => {
                                                let deptId = extra && extra.triggerNode && extra.triggerNode.props && extra.triggerNode.props.eventKey;
                                                this.state.value = deptId;
                                                // 修改formItem校验状态
                                                typeof this.props.setFiledValidateStatus === 'function' && this.props.setFiledValidateStatus(undefined);
                                                fieldProps.onChange(deptId,true);
                                                this.setState({});
                                            }}
                                        >
                                            {columnLoop(treeData)}
                                        </TreeSelect>
                                    </>
                                )
                            }
                        </PositionTypeContext.Consumer>
                    </div>
                    {
                        (!!suffixLayout && !suffixButton) &&
                        <div className="rmt-input-suffix-layout">{suffixLayout}</div>
                    }
                    {
                        (!!suffixButton && !suffixLayout) &&
                        <div className="rmt-input-suffix-layout">{this.renderSuffixButton()}</div>
                    }
                </div>
                <style>
                    {
                        `div[data-name = '${this.props.name}'] .ant-form-item-children-icon {
                            left: calc(100% - ${suffixWidth > 0 ? suffixWidth : 35}px);
                        }`
                    }
                </style>
            </>
        )
    }

    findNodeById(nodes, targetId) {
        for (var node of nodes) {
            if (node.id === targetId) {
                return node;
            }
            if (node.children) {
                const childNode = this.findNodeById(node.children, targetId);
                if (childNode) {
                    return childNode;
                }
            }
        }
        return null;
    }

    // 更新组件内部value
    updateValue(refreshData) {
        if (refreshData) {
            const updateStack = {};
            for (const item of refreshData) {
                if (Object.keys(this.props.fieldProps).includes(item)) {
                    updateStack[item] = this.props.fieldProps[item];
                }
            }
            this.setState({...updateStack})
        }else {
            this.setState({
                value: this.props.fieldProps.value,
            })
        }
    }
}

export default DeptSelect;

DeptSelect.propTypes = {
    suffixButton: PropTypes.bool,
    prefixLayout: PropTypes.node,
    suffixLayout: PropTypes.node,
    style: PropTypes.object,
    fieldProps: PropTypes.object,
}

DeptSelect.defaultProps = {
    prefixLayout: null,
    suffixButton: false,
    suffixLayout: null,
    style: {},
    fieldProps: {
        options: [],
    },
}